<div
  class="tokenfield__container"
  [ngClass]="{
    'tokenfield--disabled': settings?.isDisabled,
    'tokenfield--readonly': settings?.isReadOnly,
    'tokenfield--focused': tokenInput.matches(':focus'),
    'tokenfield--error': !!errorKey
  }"
>
  <div class="tokens__wrapper">
    <div
      *ngFor="let token of tokens; trackBy: trackByTokenId"
      [title]="token?.label || ''"
      class="token">
      <span class="token__content">{{ token?.label }}</span>

      <button
        *ngIf="!settings?.isReadOnly && !settings?.isDisabled"
        type="button"
        class="token__clear-button"
        tabindex="-1"
        (click)="removeToken(token)"
      >
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <input
      #tokenInput
      type="text"
      class="token__input"
      autocomplete="off"
      spellcheck="false"
      [attr.inputmode]="mode === 'number' ? 'numeric' : null"
      [placeholder]="tokens?.length === 0 ? settings?.placeholder : ''"
      [disabled]="settings?.isDisabled"
      [readonly]="settings?.isReadOnly"
      [value]="inputValue"
      (keydown)="onKeyDown($event)"
      (input)="onInput($event)"
      (paste)="onPaste($event)"
      (blur)="onBlur()"
    />
  </div>
</div>

<small *ngIf="errorMessage" class="tokenfield__error">
  <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
</small>
